import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-agricola-client-not-found-dialog',
  templateUrl: './agricola-client-not-found-dialog.component.html',
  styleUrls: ['./agricola-client-not-found-dialog.component.css'],
  standalone: false
})
export class AgricolaClientNotFoundDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<AgricolaClientNotFoundDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
